module.exports = __webpack_public_path__ + "static/biobeechoshotel-logo-d23c173c3245130b9b7dc890d762e324.svg";